import { TabWrap } from 'sections/TabWrap';

import { useSeo } from './Seo.hooks';

export function Seo(): React.ReactElement {
  const { sections } = useSeo();

  return <TabWrap sections={sections} />;
}
